// Shared stage grouping for the home widgets (Ship 1/2, Aug 25 2026).
// Display-only coarse buckets — NOT a money or lifecycle authority.

// Terminal + finance-end stages excluded from "live". NOT-IN keeps queries
// robust to enum growth (an unknown live stage still counts; a bad literal in
// an IN list would 400 the whole query).
export const NON_LIVE_STAGES = [
  "no_thanks",
  "insufficient_damage",
  "claims_denied",
  "cancelled",
  "closed_won",
  "closed_lost",
  "closed_inspection",
  "delinquent",
  "register_oc_warranty",
];

export const STAGE_BUCKETS: Array<{ label: string; stages: string[] }> = [
  { label: "Leads", stages: ["initial_contact", "presentation_scheduled", "follow_up", "waiting"] },
  {
    label: "Inspection",
    stages: [
      "pending_asm_review",
      "appointment_received",
      "drone_scheduled",
      "drone_complete",
      "report_in_progress",
      "qc_review",
      "report_approved",
      "needs_climb_inspection",
    ],
  },
  {
    label: "Claims",
    stages: [
      "waiting_on_claims",
      "assign_roof_specialist",
      "pre_inspection_ready",
      "pre_inspection_complete",
      "adjuster_meeting_ready",
      "adjuster_meeting_scheduled",
    ],
  },
  {
    label: "Reinspect",
    stages: ["partial_approval", "docs_and_contingency", "reinspection_ready", "reinspection_filed"],
  },
  {
    label: "Build",
    stages: [
      "install_meeting",
      "build_submitted",
      "schedule_build",
      "build_scheduled",
      "roof_complete",
      "trades_in_progress",
      "trades_complete",
    ],
  },
  {
    label: "Collect",
    stages: [
      "ready_for_supps",
      "ready_for_updated_invoice",
      "supps_waiting_on_claims",
      "supps_waiting_on_final_invoice",
      "collecting",
    ],
  },
];
